import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountsService } from '../../../accounts.service';
import { UpgradeCTADialogService } from '../../../core/get-pro/pro-upgrade-cta.service';
import { Site, SiteService } from '../../../core/site';
import { StagingService, StagingStatus } from '../../../core/staging';
import { SiteStaging } from '../../../core/staging/staging';
import { BackupTableComponent } from '../backup-table/backup-table.component';
import { AdvancedSiteSettingsApiService } from '@vendasta/wsp-wp-manager';

@Component({
  selector: 'app-backup-page',
  templateUrl: './backup-page.component.html',
  styleUrls: ['./backup-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BackupPageComponent {
  isExpress$: Observable<boolean> = of(true);
  isTemplate$: Observable<boolean> = of(true);
  currentStagingStatus$: Observable<StagingStatus>;
  @ViewChild(BackupTableComponent, { static: false })
  childTable: BackupTableComponent;

  constructor(
    private accountsService: AccountsService,
    private proCTAUpgrade: UpgradeCTADialogService,
    private siteService: SiteService,
    private stagingService: StagingService,
    private advancedSiteSettingsApiService: AdvancedSiteSettingsApiService,
  ) {
    this.isExpress$ = this.accountsService.isExpress$;
    this.isTemplate$ = this.siteService.get().pipe(map((site: Site) => site.template));
    this.currentStagingStatus$ = this.stagingService.currentStagingStatus$;
  }

  showBackupNowDialog(stagingStatus?: StagingStatus): void {
    this.childTable.showBackupDialog(stagingStatus === SiteStaging.ON);
  }

  showUpgradeCTA(): void {
    this.proCTAUpgrade
      .openUpgradeModel()
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.proCTAUpgrade.businessCenterUpgrade();
        }
      });
  }

  backupStatus = 'done'; // Default to 'done'

  onBackupStatusChange(status: string): void {
    this.backupStatus = status; // Update backup status based on child event
  }
}
